import { MultiTimeviewTimeviewResult, QuestionResultsFilterLabels, TimeviewBucketMode } from "types";

import { generatePath } from "react-router-dom";
import { querystring as qs } from "utils";
import { routePaths } from "routing";

type GetMultiTimeviewChartTitleArgs = {
  name: string;
  timegrain: TimeviewBucketMode;
};

type GetMultiTimeviewTimeviewUrlArgs = {
  uuid: string;
  date?: number;
};

/**
 * Builds the chart title for a MutliTimeview Chart.
 */
export const getMultiTimeviewChartTitle = ({ name, timegrain }: GetMultiTimeviewChartTitleArgs): string =>
  `${name} - ${timegrain.toUpperCase()} MultiTimeview`;

/**
 * Builds a link to the "Results > Timeview" page for multi timeview.
 */
export const getMultiTimeviewTimeviewUrl = ({ uuid, date }: GetMultiTimeviewTimeviewUrlArgs) =>
  `${generatePath(routePaths.MULTI_TIMEVIEW, { uuid })}/results/timeview${qs.buildSearchString({ date })}`;

/**
 * Returns the filters applied to a MultiTimeview dashlet's timeview results.
 */
export const getMultiTimeviewDashletFilters = (data: [MultiTimeviewTimeviewResult]): QuestionResultsFilterLabels => {
  return data[0]?.filters || {};
};
